let billing = (function () {
    let initBilling = function () {
        $(document).on("click", ".dwn-invoice-details", function () {
            let id = $(this).data("id");
            window.location.href = baseUrl + "/admin/billing/invoice-pdf/" + id + "/details";
        });

        $(document).on("click", ".dwn-invoice", function () {
            let id = $(this).data("id");
            window.location.href = baseUrl + "/admin/billing/invoice-pdf/" + id + "";
        });

        $(document).on("click", ".download-invoice", function () {
            let id = $(this).data("id");
            window.location.href = baseUrl + "/invoice-pdf/" + id;
        });

        $(document).on("click", ".download-invoice-details", function () {
            let id = $(this).data("id");
            window.location.href = baseUrl + "/invoice-pdf/" + id + "/details";
        });

        $(document).on("click", ".view-invoice", function () {
            let id = $(this).data("id");
            window.location.href = baseUrl + "/invoice/" + id;
        });

        $(document).on("click", ".view-invoice-details", function () {
            let id = $(this).data("id");
            window.location.href = baseUrl + "/admin/billing/invoice/" + id;
        });
    };

    return {
        // public functions
        init: function () {
            initBilling();
        },
    };
})();

$(document).ready(function () {
    billing.init();
});
